module.exports = __webpack_public_path__ + "static/media/icon-secure.3bf69f72.jpg";